import React from 'react';
import styles from './CustomButton.module.css';

const CustomButton = ({
  text,
  leftIcon,
  rightIcon,
  size = 'instagram',
  onClick,
  className,
  disabled = false,
  color = '#000',
  backgroundColor = 'var(--color-primary)',
  fontSize = '18px',
}) => {
  const sizeConfig = {
    instagram: {
      widthConfig: '100%',
      height: '5.5rem',
    },
    reserva: {
      widthConfig: '100%',
      flex: '1 1 0',
    },
    link: {
      widthConfig: '100%',
      height: '7rem',
    },
  };

  const { height, widthConfig, flex } = sizeConfig[size];

  const buttonStyles = {
    width: widthConfig,
    height,
    color: color,
    backgroundColor: backgroundColor,
    flex,
  };

  return (
    <div
      style={buttonStyles}
      className={`${styles.buttonCustom} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className='d-flex justify-content-between align-items-center'>
        {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}

        {rightIcon && <div className={styles.rightIcon}>{rightIcon}</div>}
      </div>

      <div className={styles.text} style={{ fontSize: fontSize }}>
        {text}
      </div>
    </div>
  );
};

export default CustomButton;
